import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import SpitialProfileWatchHistory from "../../components/profile/watchHistory";
import { hasAuthenticatedSession } from "../../services/authStorage";

const checkAuth = () => hasAuthenticatedSession();

const ProfileWatchHistoryPage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();

  if (!auth) {
    navigate("/login");
  }

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      const response = await httpService.get(getCMSApiRoute("action/watch"));

      const { data } = response.data;
      return data;
    } catch (err) {
      console.log(err);
      return {};
    }
  }

  useEffect(() => {
    getData().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  return (
    <RootLayout>
      <SpitialProfileWatchHistory data={data} loading={loading} />
    </RootLayout>
  );
};

export default ProfileWatchHistoryPage;
